import { useState } from "react";
import { Trash2, ImagePlus, ChevronUp, ChevronDown } from "lucide-react";
import MediaPicker from "../../components/Media/MediaPicker";
import { Button } from "@/components/ui/button";

export default function SocialImagesField({
  value,
  onChange,
}: {
  value: string[];
  onChange: (images: string[]) => void;
}) {
  const [pickerOpen, setPickerOpen] = useState(false);

  function removeAt(index: number) {
    onChange(value.filter((_, i) => i !== index));
  }

  function moveUp(index: number) {
    if (index === 0) return;
    const next = [...value];
    [next[index - 1], next[index]] = [next[index], next[index - 1]];
    onChange(next);
  }

  function moveDown(index: number) {
    if (index === value.length - 1) return;
    const next = [...value];
    [next[index], next[index + 1]] = [next[index + 1], next[index]];
    onChange(next);
  }

  function handleSelect(url: string) {
    onChange([...value, url]);
    setPickerOpen(false);
  }

  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between">
        <h3 className="text-sm font-medium">Galeri Görselleri</h3>
        <Button type="button" variant="outline" size="sm" onClick={() => setPickerOpen(true)}>
          <ImagePlus className="h-4 w-4 mr-1" />
          Görsel Ekle
        </Button>
      </div>

      <p className="text-xs text-muted-foreground">
        İlk görsel liste sayfasında kapak olarak kullanılır. Birden fazla görsel eklenirse detay
        sayfasında slider gösterilir.
      </p>

      {value.length === 0 && (
        <p className="text-sm text-muted-foreground">Henüz görsel eklenmedi.</p>
      )}

      <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
        {value.map((url, index) => (
          <div key={`${url}-${index}`} className="rounded-md border p-2 space-y-2 bg-muted/20">
            <div className="relative">
              <img
                src={url}
                alt={`Görsel ${index + 1}`}
                className="h-32 w-full object-cover rounded"
              />
              {index === 0 && (
                <span className="absolute top-1 left-1 rounded bg-black/70 px-1.5 py-0.5 text-[10px] font-medium text-white">
                  Kapak
                </span>
              )}
            </div>
            <div className="flex items-center justify-between">
              <div className="flex gap-1">
                <Button
                  type="button"
                  variant="ghost"
                  size="icon"
                  className="h-7 w-7"
                  disabled={index === 0}
                  onClick={() => moveUp(index)}
                  title="Yukarı taşı"
                >
                  <ChevronUp className="h-4 w-4" />
                </Button>
                <Button
                  type="button"
                  variant="ghost"
                  size="icon"
                  className="h-7 w-7"
                  disabled={index === value.length - 1}
                  onClick={() => moveDown(index)}
                  title="Aşağı taşı"
                >
                  <ChevronDown className="h-4 w-4" />
                </Button>
              </div>
              <Button
                type="button"
                variant="ghost"
                size="icon"
                className="h-7 w-7"
                onClick={() => removeAt(index)}
                title="Kaldır"
              >
                <Trash2 className="h-4 w-4 text-destructive" />
              </Button>
            </div>
          </div>
        ))}
      </div>

      <MediaPicker
        defaultFolder="social"
        open={pickerOpen}
        onClose={() => setPickerOpen(false)}
        onSelect={handleSelect}
      />
    </div>
  );
}
